import { motion } from 'framer-motion'
import { CircularProgress } from '@mui/material'
import { colors } from '../styles/theme'

const Loading = ({ message = 'Loading...' }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex flex-col items-center justify-center min-h-[400px] space-y-4"
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: colors.info,
        }}
      />
      <p className="text-gray-400 font-medium">{message}</p>
    </motion.div>
  )
}

export default Loading
